import { Link } from "react-router-dom";
import { FaFacebook, FaTwitter, FaInstagram, FaLinkedin } from "react-icons/fa";
import logo from "../Pages/images/logo.png";
import "./Footer.css";

const navLinks = [
  "HOME",
  "SERVICES",
  "COACHING",
  "UNIVERSITIES",
  "ABOUT US",
  "CONTACT US",
  "FREE COUNSELLING",
];

const countries = [
  { name: "United States", flag: "https://flagcdn.com/us.svg", link: "countries" },
  { name: "Canada", flag: "https://flagcdn.com/ca.svg", link: "countries" },
  { name: "Australia", flag: "https://flagcdn.com/au.svg", link: "countries" },
  { name: "United Kingdom", flag: "https://flagcdn.com/gb.svg", link: "countries" },
  { name: "New Zealand", flag: "https://flagcdn.com/nz.svg", link: "countries" },
  { name: "Germany", flag: "https://flagcdn.com/de.svg", link: "countries" },
  { name: "Ireland", flag: "https://flagcdn.com/ie.svg", link: "countries" },
];

const branches = [
  "Hyderabad - Head Office",
  "Warangal Branch",
  "Nalgonda Branch"
];

const Footer = () => {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-top">
          <img src={logo} alt="Agency Logo" className="footer-logo" />
          <p>Helping students achieve their dreams of studying abroad with expert guidance, trusted partnerships, and a personalized approach for every applicant.</p>
        </div>

        <div className="footer-content">
          <div className="footer-section">
            <h3>Quick Links</h3>
            <ul>
              {navLinks.map((item, index) => (
                <li key={index}>
                  <Link to={`/${item.toLowerCase().replace(/\s/g, "")}`}>{item}</Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="footer-section">
            <h3>Countries We Serve</h3>
            <ul>
              {countries.map((country, index) => (
                <li key={index}>
                  <Link to={`/${country.link}`}>
                    <img
                      src={country.flag}
                      alt={country.name}
                      className="flag"
                    />
                    {country.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="footer-section">
            <h3>Our Branches</h3>
            <ul>
              {branches.map((branch, index) => (
                <li key={index}>{branch}</li>
              ))}
            </ul>
          </div>

          <div className="footer-section">
            <h3>Contact Us</h3>
            <p>Email: Clyraoverseas@gmail.com</p>
            <p>Phone: +91 9618001019</p>
            <p>Office Timings: 10:00 AM - 4:00 PM</p>
            <div className="social-icons">
              <a href="https://www.instagram.com/clyraoverseas?igsh=YnVvcWtqemxhZTJn" target="_blank" rel="noopener noreferrer"><FaFacebook /></a>
              <a href="https://www.instagram.com/clyraoverseas?igsh=YnVvcWtqemxhZTJn" target="_blank" rel="noopener noreferrer"><FaTwitter /></a>
              <a href="https://www.instagram.com/clyraoverseas?igsh=YnVvcWtqemxhZTJn" target="_blank" rel="noopener noreferrer"><FaInstagram /></a>
              <a href="https://www.instagram.com/clyraoverseas?igsh=YnVvcWtqemxhZTJn" target="_blank" rel="noopener noreferrer"><FaLinkedin /></a>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <p>&copy; {new Date().getFullYear()} Clyra Overseas. All rights reserved.</p>
          <p>Designed & Developed by Akhilesh Reddy</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
